import { useEffect } from "react";
import { useParams, useLocation } from "wouter";
import { CheckCircle2 } from "lucide-react";

export default function PaiementSuccess() {
  const { paiementId } = useParams();
  const [, setLocation] = useLocation();

  useEffect(() => {
    const t = setTimeout(() => setLocation(`/paiement/${paiementId}`), 2500);
    return () => clearTimeout(t);
  }, [paiementId, setLocation]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6">
      <div className="w-24 h-24 bg-[#E4F1E8] rounded-full flex items-center justify-center mb-6 animate-bounce">
        <CheckCircle2 size={48} className="text-[#3F8F5C]" />
      </div>
      <h1 className="text-[40px] sm:text-[48px] leading-tight [font-family:'Cormorant_Garamond',serif] font-bold text-navy mb-4">
        Paiement réussi !
      </h1>
      <p className="text-lg text-navy/60">
        Redirection vers votre reçu en cours…
      </p>
    </div>
  );
}
